import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const LineGraph = ({ series, categories, title }) => {
  const [seriess, setSeriesData] = useState([])
  useEffect(() => {
    setSeriesData([series])
  }, [series])


  const options = {
    chart: {
      height: 350,
      type: 'line',
      dropShadow: {
        enabled: true,
        color: '#000',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2
      },
      toolbar: {
        show: false
      }
    },
    colors: ['#77B6EA', '#545454'],
    dataLabels: {
      enabled: true,
    },
    stroke: {
      curve: 'smooth'
    },
    title: {
      text: title,
      align: 'left'
    },
    grid: {
      borderColor: '#e7e7e7',
      row: {
        colors: ['#f3f3f3', 'transparent'],
        opacity: 0.5
      },
    },
    markers: {
      size: 1
    },
    xaxis: {
      categories: categories,
      title: {
        text: 'Dates'
      }
    },
    yaxis: {
      title: {
        text: 'Values'
      },
     
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5
    }
  };

  return (
    <div id="line-chart">
      <ReactApexChart options={options} series={seriess} type="line" height={350} />
    </div>
  );
};

export default LineGraph;
